import { ShopCard } from "draft/types";

const duelCardsPool: ShopCard[] = [
  {
    Index: 1,
    Name: "Extra Ban",
    Description: "You receive an extra Ban",
    Cost: "2 dl",
    Effects: ["addBan"],
    Frequency: 2,
  },
  {
    Index: 2,
    Name: "Random Hero",
    Description: "Play with a random hero, excluding current draft ",
    Cost: "1 dl",
    Frequency: 2,
    Effects: ["randomHero", "select:friendly"],
  },
  {
    Index: 3,
    Name: "Re-Roll",
    Description: "Re-roll a new draft",
    Cost: "3 dl",
    Frequency: 2,
    Effects: ["reroll", "select:friendly"],
  },
  {
    Index: 4,
    Name: "Another One",
    Description: "Both players acquire an additional hero",
    Cost: "1 dl",
    Frequency: 2,
    Effects: ["anotherOne"],
  },
  {
    Index: 5,
    Name: "Trade",
    Description: "Change draft with your opponent",
    Cost: "3 dl",
    Frequency: 1,
    Effects: ["duelTrade"],
  },
  {
    Index: 6,
    Name: "Surrekamp",
    Description:
      "Both players are assigned a hero of tier D or worse. The stage is randomized to meme-stage. The draft ends",
    Cost: "3 dl",
    Frequency: 1,
    Effects: ["surrekamp"],
  },
  {
    Index: 7,
    Name: "Cuckio",
    Description:
      "Select an enemy hero. The other heroes to that player gets banned",
    Cost: "3 dl",
    Effects: ["cuckio"],
    Frequency: 1,
  },
];

export const LoadDuelCardsPool = (): ShopCard[] => {
  const shopCards: ShopCard[] = [];
  let uniqueIndex = 0;

  duelCardsPool.forEach((card) => {
    var frequency = card.Frequency ? card.Frequency : 0;
    for (var i = 0; i < frequency; i++) {
      shopCards.push({ ...card, Index: uniqueIndex++ });
    }
  });

  if (shopCards.length < 4) {
    throw new Error("Not enough cards to create a duel!");
  }

  return shopCards;
};
